export enum EstimationUomEnum {
  HOURS = "Hours",
  DAYS = "Days",
  FIBONACCI_POINTS = "Fibonacci points",
}
